module.exports = __webpack_public_path__ + "img/020.82ddd0a8.png";